// Poi Page
export const INIT_POI_DETAILS = 'initPoiDetails';
export const FETCH_POI = {
  LOADING: 'fetchPoiLoading',
  SUCCESS: 'fetchPoiSuccess',
  FAIL: 'fetchPoiFail'
};

export const FETCH_POI_PRODUCTS = {
  LOADING: 'fetchPoiProductsLoading',
  SUCCESS: 'fetchPoiProductsSuccess',
  FAIL: 'fetchPoiProductsFail'
};

export const FETCH_TRIP_OF_POI_DETAILS = {
  LOADING: 'fetchTripOfPoiDetailLoading',
  SUCCESS: 'fetchTripOfPoiDetailSuccess',
  FAIL: 'fetchTripOfPoiDetailFail'
};

export const ADD_POI_OF_POIPAGE_TO_TRIP = {
  LOADING: 'addPoiOfPoiPageToTripLoading',
  SUCCESS: 'addPoiOfPoiPageToTripSuccess',
  FAIL: 'addPoiOfPoiPageToTripFail'
};
export const ADD_POI_TO_MY_COLLECTION = {
  INIT: 'addPoiToMyCollectionInit',
  LOADING: 'addPoiToMyCollectionLoading',
  SUCCESS: 'addPoiToMyCollectionSuccess',
  FAIL: 'addPoiToMyCollectionFail'
};

export const SHOW_DESCRIPTTION = 'showDescription';
export const SET_CURRENT_IMG = 'setCurrentImg';
export const SET_CURRENT_TRIP = 'setCurrentTrip';
export const SET_DETAIL_CARD = 'setDetailCardShow';
export const POI_POPUP = {
  SHOW: 'showAddPoiPopup',
  CLOSE: 'closeAddPoiPopup'
};
export const BACK_TO_STEP1 = 'backToStep1';
export const SET_CURRENT_DAY = 'setCurrentDay';
